export const ITEM_LIMIT_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE = 25;
export const MINIMUM_SEARCH_STRING_LENGTH = 3;
export const DEBOUNCE_TIME = 1000;
